import { Show } from "solid-js";
import Text from "../../text/Text";
import { isNil } from "lodash-es";
import type { IconTileOption, ListItemHtmlProps } from "../../../types/Menu";
import ListItemContainer from "./ListItemContainer";
import { IconTile } from "../../icon/IconTile";

type IconTileListItemProps = Omit<IconTileOption<null>, "variant" | "value"> & {
  htmlProps: ListItemHtmlProps;
};

const IconTileListItem = (props: IconTileListItemProps) => (
  <ListItemContainer htmlProps={props.htmlProps} disabled={props.disabled} hidden={props.hidden} type="row">
    <IconTile icon={props.icon} size="sm" border />
    <div class="flex min-w-0 flex-col">
      <Text
        as="span"
        truncate
        text={props.label}
        class="group-disabled:text-disabled"
        classList={{
          "text-base-regular text-primary": isNil(props.description),
          "text-base-medium text-primary": !isNil(props.description),
        }}
      />
      <Show when={props.description}>
        {(description) => (
          <Text
            as="span"
            truncate
            text={description()}
            class="text-base-regular text-secondary group-disabled:text-disabled"
            classList={{ "group-aria-selected:text-primary group-selected:text-primary": props.disabled !== true }}
          />
        )}
      </Show>
    </div>
  </ListItemContainer>
);

export default IconTileListItem;
